<template>
  <sh-api-intro-card content-path="/api-intro.html"/>
</template>

<script>
    import ApiIntroCard from "../../components/common/ApiIntroCard";

    export default {
        name : "App",
        props : {
            content_path : String,
        },
        components : {
            "sh-api-intro-card" : ApiIntroCard
        },
    }
</script>

<style scoped>

</style>
